import { Injectable, inject } from "@angular/core";
import { CanActivate } from "@angular/router";
import { LocaleService } from "src/app/services/locale.service";
import { sntLog } from "src/app/common/logger";

const logger = sntLog("ProvideBaseLocaleOverrideGuard");

@Injectable()
export class ProvideBaseLocaleOverrideGuard implements CanActivate {
  private readonly localeService = inject(LocaleService);

  async canActivate(): Promise<boolean> {
    const localeToSet =
      await this.localeService.initializeFromUrlAndPreferences();

    logger.debug(`localeToSet: ${localeToSet}`);

    return true;
  }
}
